module.exports = __webpack_public_path__ + "img/1525483200.16acfc54.jpg";